module.exports = __webpack_public_path__ + "img/messages-white.dbf98792.svg";